<template>
  <div class="major-project">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">易隆创·重点方案</div>
        <div class="module-subtitle">深入细分场景，提供准确的行业解决方案</div>
      </div>
      <div class="module-body">
        <div class="data-item" v-for="(item, index) in dataList" :key="index" @click="viewDetail(item.id)">
          <div class="data-item-top" :style="{ backgroundImage: `url(${styleList[index].background})`, '--color': styleList[index].color }">
            <div class="title" :title="item.name">
              <div class="title-text single-ellipsis">{{ item.name }}</div>
            </div>
            <div class="slogan single-ellipsis" v-for="(tag, index) in item.solutionTag?.split(',').slice(0, 3)" :key="index" :title="tag">{{ tag }}</div>
          </div>
          <div class="data-item-bottom">
            <div class="title single-ellipsis" :title="item.name">{{ item.name }}</div>
            <div class="remark two-lines-ellipsis" :title="item.remark">{{ item.remark }}</div>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as SchemeApi from '@/api/scheme';

export default {
  data () {
    return {
      styleList: [
        { color: '#0055FF', background: require('@/assets/img/scheme/MajorScheme/item_bg_zhsw.png') },
        { color: '#10A695', background: require('@/assets/img/scheme/MajorScheme/item_bg_nzt.png') },
        { color: '#FF7B5B', background: require('@/assets/img/scheme/MajorScheme/item_bg_qyly.png') },
      ],
      dataList: [],
      /* dataList: [{
        title: '智慧水务解决方案',
        color: '#0055FF',
        background: require('@/assets/img/scheme/MajorScheme/item_bg_zhsw.png'),
        slogans: ['以数据贯通为基础，让水务管理 “可视、可管、可控”', '聚焦水务管理核心痛点，提供靶向解决路径', '从部署到运维，全周期护航价值实现'],
        remark: '搭建统一的智慧水务云平台，整合各环节数据，建立标准化数据模型，实现 “水源 - 供水 - 排水 - 污水” 全链路数据互通，为决策提供数据支撑；'
      }, {
        title: '农智通解决方案',
        color: '#10A695',
        background: require('@/assets/img/scheme/MajorScheme/item_bg_nzt.png'),
        slogans: ['技术适配性（语音/方言交互）', '场景纵深（从种植到交易全链路）', '政策借力（地方试点与补贴）'],
        remark: '旨在解决农民获取农业科技信息门槛高、专业性强的问题，通过技术创新实现“零门槛”智慧农业服务。'
      }, {
        title: '全域旅游解决方案',
        color: '#FF7B5B',
        background: require('@/assets/img/scheme/MajorScheme/item_bg_qyly.png'),
        slogans: ['让旅游体验 “无边界、有温度、可延续”', '覆盖全域旅游核心环节', '从部署到运维，全周期护航价值实现'],
        remark: '基于对旅游目的地痛点的深度洞察，构建 “数字赋能 + 业态创新 + 服务升级” 三位一体的全域旅游解决方案，助力区域从 “单一景区盈利” 向 “全域价值共创” 转型。'
      }] */
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    async getDataList() {
      try {
        const res = await SchemeApi.queryLimit({ pageSize: 3, type: 'home' });
        if (res?.code === '00000') {
          this.dataList = res.rows;
        }
      } catch (error) {
        console.error('获取数据失败', error);
      }
    },
    viewDetail(id) {
      this.$router.push({ path: '/scheme/view', query: { id } });
    }
  },
};
</script>

<style lang="less" scoped>
.major-project {
  padding: 64px 0 180px;

  .content-center {
    .module-body {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      .data-item {
        width: 404px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: 0.3s;
        .data-item-top {
          height: 340px;
          padding: 48px 20px 0 40px;
          background-size: 100% 100%;
          .title {
            margin-bottom: 66px;
            position: relative;
            .title-text {
              font-family: @font-bold;
              font-size: 32px;
              color: var(--color);
            }
            &::after {
              content: '';
              width: 24px;
              height: 4px;
              background-color: var(--color);
              position: absolute;
              left: 2px;
              bottom: -28px;
            }
          }
          .slogan {
            margin-bottom: 16px;
            padding: 0 6px;
            font-size: 14px;
            line-height: 30px;
          }
        }
        .data-item-bottom {
          height: 160px;
          padding: 20px;
          background-color: #fff;
          position: relative;
          .title {
            font-family: @font-medium;
            font-size: 18px;
            transition: 0.3s;
          }
          .remark {
            margin-top: 12px;
            font-size: 14px;
            color: #666;
            text-align: justify;
            line-height: 1.6;
            transition: 0.3s;
          }
          .el-icon-right {
            font-size: 20px;
            color: #666;
            position: absolute;
            right: 20px;
            bottom: 20px;
            transition: 0.3s;
          }
        }
        &:hover {
          box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
          .data-item-bottom {
            .title,
            .remark,
            .el-icon-right {
              color: @primary-color;
            }
          }
        }
      }
    }
  }
}
</style>
